import { FC } from 'react';
import { Modal } from 'react-bootstrap';

interface UserTableModalProps {
    user: any;
    onClose: () => void;
    show: boolean;
}

export const ApprovedListingDetailsMain: FC<UserTableModalProps> = ({ user, onClose, show }) => {
    return (
        <Modal
            className='modal fade'
            id='kt_modal_view_user'
            data-backdrop='static'
            tabIndex={-1}
            role='dialog'
            show={show}
            centered
            size="lg"
        >
            <div className="modal-content">
                <div className="modal-header pb-0 border-0 justify-content-end">
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={onClose}> X
                    </div>
                </div>

                <div className="modal-body scroll-y mx-5 mx-xl-18 pt-0">
                    <div className="text-center mb-13">
                        <h1 className="mb-3">Item Details</h1>
                    </div>

                    <div className="table-responsive">
                        {/* <h3>Listing Information</h3> */}
                        {/* <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                            <thead>
                                <tr className="fw-bold text-muted bg-light">
                                    <th className="min-w-100px ps-4"
                                        style={{
                                            backgroundColor: '#BFD7ED',
                                            color: 'black',
                                            fontWeight: 'bold'
                                        }}
                                    >Grade</th>
                                    <th className="min-w-100px ps-4"
                                        style={{
                                            backgroundColor: '#BFD7ED',
                                            color: 'black',
                                            fontWeight: 'bold'
                                        }}
                                    >Color</th>
                                    <th className="min-w-100px ps-4"
                                        style={{
                                            backgroundColor: '#BFD7ED',
                                            color: 'black',
                                            fontWeight: 'bold'
                                        }}
                                    >Packaginng</th>
                                    <th className="min-w-100px ps-4"
                                        style={{
                                            backgroundColor: '#BFD7ED',
                                            color: 'black',
                                            fontWeight: 'bold'
                                        }}
                                    >Qty (kg)</th>
                                    <th className="min-w-100px ps-4"
                                        style={{
                                            backgroundColor: '#BFD7ED',
                                            color: 'black',
                                            fontWeight: 'bold'
                                        }}
                                    >Price (INR/Kg)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>

                                    <td>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user.orderDetail[0]?.items[0]?.grade || 'N/A'}
                                        </span>
                                    </td>
                                    <td className="ps-4">
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user.orderDetail[0]?.items[0]?.color || 'N/A'}
                                        </span>
                                    </td>

                                    <td>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user.packagingType || 'N/A'}
                                        </span>
                                    </td>
                                    <td>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user.orderDetail[0]?.items[0]?.quantity || 'N/A'}
                                        </span>
                                    </td>
                                    <td>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user.orderDetail[0]?.items[0]?.price || 'N/A'}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table> */}
                        <div className="table-responsive">
                            <table style={{
                                width: "100%",
                                borderCollapse: "collapse",
                                marginBottom: "20px",
                                border: "1px solid #ddd"
                            }}>
                                <thead>
                                    <tr>
                                        <th colSpan={2} style={{
                                            backgroundColor: "#BFD7ED",
                                            color: "black",
                                            fontWeight: "bold",
                                            padding: "12px",
                                            textAlign: "left",
                                            border: "1px solid #ddd"
                                        }}>
                                            Listing Information
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style={{ width: "30%", padding: "10px", border: "1px solid #ddd", fontWeight: "bold" }}>Grade</td>
                                        <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                            {user.orderDetail?.[0]?.items?.[0]?.grade || 'N/A'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: "10px", border: "1px solid #ddd", fontWeight: "bold" }}>Color</td>
                                        <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                            {user.orderDetail?.[0]?.items?.[0]?.color || 'N/A'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: "10px", border: "1px solid #ddd", fontWeight: "bold" }}>Packaging</td>
                                        <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                            {user.packagingType || 'N/A'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: "10px", border: "1px solid #ddd", fontWeight: "bold" }}>Qty (Kg)</td>
                                        <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                            {user.orderDetail?.[0]?.items?.[0]?.quantity || 'N/A'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: "10px", border: "1px solid #ddd", fontWeight: "bold" }}>Price (INR/Kg)</td>
                                        <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                            {user.orderDetail?.[0]?.items?.[0]?.price || 'N/A'}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>


                    <div className="table-responsive">
                        {/* <h3>Verification Information</h3> */}
                        {/* <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                            <thead>
                                <tr className="fw-bold text-muted bg-light">
                                    <th className="min-w-100px ps-4"
                                        style={{
                                            backgroundColor: '#BFD7ED',
                                            color: 'black',
                                            fontWeight: 'bold'
                                        }}
                                    >Grade</th>
                                    <th className="min-w-100px ps-4"
                                        style={{
                                            backgroundColor: '#BFD7ED',
                                            color: 'black',
                                            fontWeight: 'bold'
                                        }}
                                    >Color</th>
                                    <th className="min-w-100px ps-4"
                                        style={{
                                            backgroundColor: '#BFD7ED',
                                            color: 'black',
                                            fontWeight: 'bold'
                                        }}
                                    >Packaginng</th>
                                    <th className="min-w-100px ps-4"
                                        style={{
                                            backgroundColor: '#BFD7ED',
                                            color: 'black',
                                            fontWeight: 'bold'
                                        }}
                                    >Qty (Kg)</th>
                                    <th className="min-w-100px ps-4"
                                        style={{
                                            backgroundColor: '#BFD7ED',
                                            color: 'black',
                                            fontWeight: 'bold'
                                        }}
                                    >Price (INR/Kg)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>

                                    <td>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user.verifiedOrderDetails[0]?.items[0]?.grade || 'N/A'}
                                        </span>
                                    </td>
                                    <td className="ps-4">
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user.verifiedOrderDetails[0]?.items[0]?.color || 'N/A'}
                                        </span>
                                    </td>

                                    <td>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {'N/A'}
                                        </span>
                                    </td>
                                    <td>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user.verifiedOrderDetails[0]?.items[0]?.quantity || 'N/A'}
                                        </span>
                                    </td>
                                    <td>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user.verifiedOrderDetails[0]?.items[0]?.price || 'N/A'}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table> */}

                        <div className="table-responsive">
                            <table style={{
                                width: "100%",
                                borderCollapse: "collapse",
                                marginBottom: "20px",
                                border: "1px solid #ddd"
                            }}>
                                <thead>
                                    <tr>
                                        <th colSpan={2} style={{
                                            backgroundColor: "#BFD7ED",
                                            color: "black",
                                            fontWeight: "bold",
                                            padding: "12px",
                                            textAlign: "left",
                                            border: "1px solid #ddd"
                                        }}>
                                            Verification Information
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style={{
                                            width: "30%",
                                            padding: "10px",
                                            border: "1px solid #ddd",
                                            fontWeight: "bold"
                                        }}>
                                            Grade
                                        </td>
                                        <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                            {user.verifiedOrderDetails?.[0]?.items?.[0]?.grade || 'N/A'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: "10px", border: "1px solid #ddd", fontWeight: "bold" }}>
                                            Color
                                        </td>
                                        <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                            {user.verifiedOrderDetails?.[0]?.items?.[0]?.color || 'N/A'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: "10px", border: "1px solid #ddd", fontWeight: "bold" }}>
                                            Packaging
                                        </td>
                                        <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                            {'N/A'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: "10px", border: "1px solid #ddd", fontWeight: "bold" }}>
                                            Qty (Kg)
                                        </td>
                                        <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                            {user.verifiedOrderDetails?.[0]?.items?.[0]?.quantity || 'N/A'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: "10px", border: "1px solid #ddd", fontWeight: "bold" }}>
                                            Price (INR/Kg)
                                        </td>
                                        <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                            {user.verifiedOrderDetails?.[0]?.items?.[0]?.price || 'N/A'}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>












                    <div className="table-responsive mt-8">
                        <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                            <thead>
                                <tr className="fw-bold text-muted bg-light">
                                    <th className="min-w-100px ps-4"
                                        style={{
                                            backgroundColor: '#BFD7ED',
                                            color: 'black',
                                            fontWeight: 'bold'
                                        }}
                                    >Verification Images</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <div className="d-flex gap-4 flex-wrap">
                                            {user.images?.filter(img => img.docType === 'VERIFIED_DOC').map((img, index) => (
                                                <div key={index} className="text-center">
                                                    <img
                                                        src={img.docUrl}
                                                        alt={`Verification Document ${index + 1}`}
                                                        className="h-150px w-150px object-cover rounded cursor-pointer"
                                                        style={{ maxWidth: '300px', border: '1px solid #eee' }}
                                                        onClick={() => window.open(img.docUrl, '_blank')}
                                                        onError={(e) => {
                                                            e.currentTarget.src = '/media/avatars/blank.png';
                                                        }}
                                                    />
                                                </div>
                                            ))}
                                            {!user.images?.some(img => img.docType === 'VERIFIED_DOC') && (
                                                <span className="text-dark fw-semibold d-block fs-6">N/A</span>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="table-responsive mt-8">
                        <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                            <thead>
                                <tr className="fw-bold text-muted bg-light">
                                    <th className="min-w-100px ps-4"
                                        style={{
                                            backgroundColor: '#BFD7ED',
                                            color: 'black',
                                            fontWeight: 'bold'
                                        }}
                                    >Listed Images</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <div className="d-flex gap-4 flex-wrap">
                                            {user.images?.filter(img => img.docType === 'MATERIAL_DOC' || img.docType === 'SALE_DOC').map((img, index) => (
                                                <div key={index} className="text-center">
                                                    <img
                                                        src={img.docUrl}
                                                        alt={`${img.docType === 'MATERIAL_DOC' ? 'Material' : 'Sale'} Document ${index + 1}`}
                                                        className="h-150px w-150px object-cover rounded cursor-pointer"
                                                        style={{ maxWidth: '300px', border: '1px solid #eee' }}
                                                        onClick={() => window.open(img.docUrl, '_blank')}
                                                        onError={(e) => {
                                                            e.currentTarget.src = '/media/avatars/blank.png';
                                                        }}
                                                    />
                                                    {/* <p className="mt-2 text-sm font-medium">{img.docType === 'MATERIAL_DOC' ? 'Material Document' : 'Sale Document'}</p> */}
                                                </div>
                                            ))}
                                            {/* {!user.images?.some(img => img.docType === 'VERIFIED_DOC') && (
                                                <span className="text-dark fw-semibold d-block fs-6">N/A</span>
                                            )} */}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>




                    <div className="table-responsive mt-8">
                        <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                            <thead>
                                <tr className="fw-bold text-muted bg-light">
                                    <th className="min-w-100px ps-4"
                                        style={{
                                            backgroundColor: '#BFD7ED',
                                            color: 'black',
                                            fontWeight: 'bold'
                                        }}
                                    >Purchase Order</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <div className="d-flex gap-4 align-items-center">
                                            {user.images?.filter(img => img.docType === 'PO_IMAGE').map((img, index) => (
                                                <div key={index} className="d-flex align-items-center">
                                                    <i
                                                        className="bi bi-file-pdf text-danger cursor-pointer"
                                                        style={{ fontSize: '3rem' }}
                                                        onClick={() => window.open(img.docUrl, '_blank')}
                                                        title="View PDF"
                                                    ></i>
                                                </div>
                                            ))}
                                            {!user.images?.some(img => img.docType === 'PO_IMAGE') && (
                                                <span className="text-dark fw-semibold d-block fs-6">N/A</span>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>





                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-light"
                            onClick={onClose}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};